import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, BookOpen, FileText, AlertTriangle } from 'lucide-react';
import permissionsService from '../../services/permissionsService';
import PageHeader from '../Shared/PageHeader';
import { PageLoader } from '../ui';
import StudyList from './StudyList';

// Study Builder home (FECOA-2174): the study drafts straight away, with one
// clear way to start a new study.
const StudyBuilderMain = () => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const canAccess = await permissionsService.hasPermission(
          permissionsService.PERMISSIONS.ACCESS_STUDY_BUILDER
        );
        setHasAccess(canAccess);
      } catch (error) {
        console.error('Error checking study builder permission:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []);

  useEffect(() => {
    if (hasAccess === false) {
      const timer = setTimeout(() => {
        navigate('/studies', {
          state: {
            accessDenied: true,
            message: 'You do not have permission to access the Study Builder.'
          }
        });
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [hasAccess, navigate]);

  if (loading) {
    return <PageLoader label="Loading Study Builder" />;
  }

  // Show access denied message (will be briefly shown before redirect)
  if (!hasAccess) {
    return (
      <div className="flex justify-center py-16">
        <div className="card max-w-md p-8 text-center">
          <AlertTriangle className="mx-auto mb-3 h-8 w-8 text-danger-500" />
          <h2 className="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">Access Denied</h2>
          <p className="mb-5 text-sm text-gray-600 dark:text-gray-300">You do not have permission to access the Study Builder.</p>
          <button onClick={() => navigate('/studies')} className="btn btn-primary">
            Return to Studies
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        icon={BookOpen}
        title="Study Builder"
        subtitle="Create a study design with arms, schedules and assessments, then submit it for approval."
      >
        <button type="button" onClick={() => navigate('/studybuilder/create')} className="btn btn-primary">
          <Plus className="h-4 w-4" />
          Create Study
        </button>
        <button type="button" onClick={() => navigate('/assessment-builder')} className="btn btn-secondary">
          <FileText className="h-4 w-4" />
          Open Assessment Builder
        </button>
      </PageHeader>

      <StudyList embedded />
    </div>
  );
};

export default StudyBuilderMain;
